var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 4H7C4 4 2 5.5 2 9V16C2 19.5 4 21 7 21H17C20 21 22 19.5 22 16V9C22 5.5 20 4 17 4ZM17.47 10.09L14.34 12.59C13.68 13.12 12.84 13.38 12 13.38C11.16 13.38 10.31 13.12 9.66 12.59L6.53 10.09C6.21 9.83 6.16 9.35 6.41 9.03C6.67 8.71 7.14 8.65 7.46 8.91L10.59 11.41C11.35 12.02 12.64 12.02 13.4 11.41L16.53 8.91C16.85 8.65 17.33 8.7 17.58 9.03C17.84 9.35 17.79 9.83 17.47 10.09Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.8cc842c6bd34154fef27aba39d2949dc.svg";
export { ForwardRef as ReactComponent };